/* @flow */
import type { Action } from "../action";
import type { Profile } from "../CommonTypes";

type State = Profile | null;

function onSocketMessage(state, payload) {
  if (!state) {
    return state; // return whatever it is
  }

  if (state.id !== payload.user_id) {
    return state;
  }

  switch (payload.op) {
    case "turnoverChanged":
      if (!state.bonus) {
        return state;
      }

      return {
        ...state,
        bonus: {
          ...state.bonus,
          bonus_sum:
            payload.turnover === 0 && state.bonus.turnover > 0
              ? 0
              : state.bonus.bonus_sum,
          turnover: payload.turnover
        }
      };
    case "statusChanged":
      // Verification status change
      return {
        ...state,
        status: payload.status
      };
    default:
      return state;
  }
}

function settings(state?: State = null, action: Action): State {
  switch (action.type) {
    case "RECEIVE_PROFILE":
      return action.payload;
    case "UPDATE_PROFILE":
      return { ...state, ...action.payload };
    case "UPDATE_LOCALE":
      return state != null ? { ...state, locale: action.payload } : state;
    case "INVALIDATE_PROFILE":
      try {
        const timerView = sessionStorage.getItem("hideBonusTimer");
        if (timerView != null) {
          sessionStorage.removeItem("hideBonusTimer");
        }
      } catch (error) {
        console.error(`SessionStorage: ${error}`);
      }
      return null;
    case "RECEIVE_SOCKET_MESSAGE":
      return onSocketMessage(state, action.payload);
    default:
      return state;
  }
}

export default settings;



// WEBPACK FOOTER //
// ./src/redux/reducer/profile.js